<template>
  <nav class="navbar" :class="navbarClass" :key="navKey">
    <div class="navbar-content lr-page-container">
      <lr-link class="navbar-logo" to="/" @click="handleLogoClick">
        <img v-show="isWhiteLogo" src="~/assets/image/logo.svg" alt="" />
        <img v-show="!isWhiteLogo" src="~/assets/image/logo_n.svg" alt="" />
      </lr-link>

      <menu-list :data="menu" @check-menulist-active="checkMenuListActive"></menu-list>

      <search
        class="navbar-search"
        :class="{ focus: isSearchFocus, login: !!$store.state.user.userInfo }"
        @focus="handleFocus"
        @blur="handleBlur"
        @search="handleSearch"
        v-show="isNavSearchShow"
        showClear
      ></search>

      <user-info class="navbar-user-info"></user-info>
    </div>
  </nav>
</template>

<script>
import MenuList from './menu-list';
import Search from './search';
import UserInfo from './user-info';

export default {
  name: 'PageNavbar',

  serverCacheKey: ({ updated }) => updated,

  components: {
    MenuList,
    Search,
    UserInfo,
  },

  data() {
    return {
      isSearchFocus: false,
      navbarClass: '', // 默认是在首页置顶添加样式
      isWhiteLogo: true,
      isMenuListActive: false,
      isNavStyleChange: true, // 默认是在首页置顶，navbar样式是改变的
      navKey: 0,
      isNavSearchShow: this.$nuxt.$route.name === 'home' ? false : true,
    };
  },

  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    updated: String,
  },

  computed: {
    /**
     * 展示navbar为黑色的情况
     * 1、不在banner高度处
     * 2、hover menu时
     */
    isNavbarNormal() {
      if (this.$nuxt.$route.name === 'home') {
        return this.isMenuListActive || !this.isNavStyleChange;
      }
      return true;
    }
  },

  watch: {
    isNavbarNormal: {
      handler: function(newVal) {
        // console.log('isNavbarNormal', newVal);
        // console.log('isMenuListActive', this.isMenuListActive);
        // console.log('isNavStyleChange', this.isNavStyleChange);
        if (newVal) {
          this.navbarClass = '';
          this.isWhiteLogo = false;
        } else {
          this.navbarClass = 'navbar-banner';
          this.isWhiteLogo = true;
        }
      },
      immediate: true
    }
  },

  methods: {
    handleLogoClick() {
      this.$collect.nav_click({ click: 'logo' });
      this.$collect.homepageNavigationClick({ operation: 'logo' });
    },

    handleFocus() {
      this.isSearchFocus = true;
      this.$collect.nav_click({ click: 'seach' });
    },

    handleBlur() {
      this.isSearchFocus = false;
    },

    handleSearch(action) {
      if (action == 'enter') {
        this.$collect.nav_click({ click: 'seach_enter' });
      }
    },

    checkMenuListActive(active) { // 下拉menu是否被展开
      this.isMenuListActive = active;
    }
  },

  mounted() {
    this.$collect.homepageNavigationShow({ show: 'navigation' });
    this.navKey = 1;
    // 监听navbar是否在banner图里面
    this.$eventBus.$on('@check_navbar_in_default_height', ({ isNavStyleChange, isNavSearchShow }) => {
      this.isNavStyleChange = isNavStyleChange;
      this.isNavSearchShow = isNavSearchShow;
    });
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: #ffffff;
  z-index: 9999;
  border-bottom: 1px solid rgba(17, 19, 23, 0.1);
  transition: all linear 0.05s;

  &-content {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 12px;
  }

  &-logo {
    display: block;
    width: 114px;
    height: 29px;
    margin-right: 48px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  &-banner {
    position: absolute;
    background: transparent;
    border-bottom: none;
    ::v-deep .nav-menu-list-item {
      a {
        color: #fff;
        &.active {
          font-weight: bold;
        }
        &.active,
        &:hover {
          color: #fff;
          &::after {
            background: #fff;
          }
        }
      }
    }

    ::v-deep .user-info-no-log {
      background-color: #fff;
      > a {
        color: #2C71FA;
      }
      &:hover {
        background: white;
        > a {
          color: #5794FF;
        }
      }
      &:active:not(:disabled) {
        background: white;
        > a {
          color: #1C53D4;
        }
      }
    }

    ::v-deep .user-info-had-log {
      > a {
        > img {
            border: 2px solid rgba(255, 255, 255, 0.3);
        }
      }
    }
  }

  .navbar-search {
    position: absolute;
    right: 124px;
    top: 0;

    &.login {
      right: 68px;

      &.focus {
        width: 360px;
      }
    }

    &.focus {
      width: 308px;
    }
  }

  .navbar-user-info {
    position: absolute;
    right: 12px;
    top: 0;
  }
}
</style>
